import React from 'react';
import RadioGroupField from 'components/RadioGroupField';
import useOptions from '../../hooks/useOptions';

import './ExitTimelineField.styles.scss';
import './ExitTimelineField.styles.responsive.scss';

const ExitTimelineField: React.FC = () => {
  const { exitTimelineOptions } = useOptions();

  return (
    <div className="exit-timeline-field">
      <RadioGroupField
        name="exitTimeline"
        options={exitTimelineOptions}
        styled
      />
    </div>
  );
};

export default ExitTimelineField;
